import { useSelector } from 'react-redux';
import { getOfficeHours, selectUpcomingHours } from 'redux/modules/officeHour';
import { useActions } from 'utils/useActions';

export const useConnect = () => {
  const officeHours = useSelector(selectUpcomingHours);

  const actions = useActions({
    getOfficeHours: getOfficeHours.request,
  });

  return {
    ...actions,
    officeHours,
  };
};
